import styled, { css } from 'styled-components';
import Typography from '../../../../typography';
const footerTitleStyles = () => css `
	margin: 0;
`;
export const StyledFooterTitle = styled(Typography).attrs((props) => ({
    variant: 'component-title',
    tagName: props.tagName || 'h4',
})) `
	${footerTitleStyles}
`;
